<template>
  <v-autocomplete
    v-model="selected"
    :items="options"
    :loading="loading"
    :search-input.sync="searchTerm"
    hide-no-data
    no-filter
    item-value="id"
    :label="label"
    @input="handleInput"
    :disabled="disabled"
    :hint="hint"
    :placeholder="searchTerm"
    :required="required"
    :rules="rules || []"
    return-object
    clearable
  >
    <template slot="item" slot-scope="{ item: qualification }">
      <v-list-tile-avatar v-if="qualification.institution">
        <img
          :src="qualification.institution.logo || '/img/missing/logos/institutions/original.png'"
        />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-if="qualification.display">{{
          qualification.display
        }}</v-list-tile-title>
        <v-list-tile-sub-title v-if="qualification.institution">
          <span v-if="qualification.institution.name">{{ qualification.institution.name }}</span>
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </template>
    <template slot="selection" slot-scope="{ item: qualification }">
      <v-chip>
        <v-avatar v-if="qualification.institution">
          <img
            :src="qualification.institution.logo || '/img/missing/logos/institutions/original.png'"
          />
        </v-avatar>
        {{ qualification.display }}
      </v-chip>
    </template>
  </v-autocomplete>
</template>

<script>
// Helpers
import _ from 'lodash'
import { mapGetters } from 'vuex'

// Vue Component
export default {
  props: {
    value: [Object, Number],
    rules: Array,
    required: Boolean,
    disabled: Boolean,
		label: { type: String, default: () => 'Qualification' },
    hint: { type: String, default: () => 'Search Qualifications' },
  },

  created() {
    if (_.get(this.value, 'id')) {
      Vue.$http.get(`admin/qualifications/${this.value.id}`).then(response => {
        this.qualifications = [response.data]
        this.selected = response.data
      })
    } else if (Number.isInteger(this.value)) {
      Vue.$http.get(`admin/qualifications/${this.value}`).then(response => {
        this.qualifications = [response.data]
        this.selected = response.data
      })
    }
  },

  data() {
    return {
      selected: {},
      loading: false,
      searchTerm: '',
      qualifications: [],
    }
  },

  computed: {
    options() {
      if (this.selected && this.selected.id) return [this.selected, ...this.qualifications]
      return this.qualifications.length ? this.qualifications : []
    },
  },

  watch: {
    searchTerm: _.debounce(function(search) {
      // search is null on initial load
      if (search && search.length > 2) {
        this.search()
      }
    }, 500),
  },

  methods: {
    handleInput(qualification) {
      if (!_.get(qualification, 'id')) return (this.selected = null)

      this.selected = qualification
      this.$emit('input', qualification)
    },

    search() {
      // Update options
      this.loading = true
      Vue.$http
        .get(`admin/qualifications/?search=${this.searchTerm}`)
        .then(response => {
          this.qualifications = response.data.items
        })
        .catch(error => {
          // console.log(error)
        })
        .finally(() => (this.loading = false))
    },
  },
}
</script>
